import PoolDetail from "./PoolDetail.component";

export default PoolDetail;
